import apiClient from '../../../common/functions/api_axios_instance.function';
import { handleApiError } from '../../../common/functions/errorHandler.function';
import { RAN_DB_DOWNLOAD_EXCEL } from '../../../common/constants/constants';

export const downloadExcelFiberSites = async () => {
  try {
    const response = await apiClient.get(RAN_DB_DOWNLOAD_EXCEL, {
      responseType: 'blob', // Important for file downloads
    });

    // Create a blob from the response
    const blob = new Blob([response.data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });

    // Create a download link
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;

    // Generate filename with current date
    const currentDate = new Date().toISOString().split('T')[0];
    link.download = `fiber_sites_${currentDate}.xlsx`;

    // Trigger download
    document.body.appendChild(link);
    link.click();

    // Clean up
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);

    return response;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};
